import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class AppGroupFeed extends Component {
  @service router;

  get model() {
    return this.args.model;
  }

  @action
  openPendingPostHashTag(hash) {
    this.router.transitionTo('app.group', { queryParams: { tag: hash } });
  }

  @action
  goToSettings() {
    this.router.transitionTo('app.group.settings', { queryParams: { initialTabNumber: 1 } });
  }
}
